import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster, toast } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { LogoMark } from "@/components/Logo";
import { api } from "@/lib/api";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((res) => navigate("/admin", { replace: true, state: { user: res.data } }))
      .catch((err) => {
        const detail = err.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : "Google Login fehlgeschlagen");
        navigate("/admin", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian" data-testid="auth-callback-loading">
      <div className="animate-pulse">
        <LogoMark size={48} />
      </div>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Synchronous fragment check during render — prevents race with ProtectedRoute state
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{ style: { background: "#14213A", border: "1px solid #24334F", color: "#F2F5FA", borderRadius: "2px" } }}
      />
    </LanguageProvider>
  );
}

export default App;
